var ResourcesClass = (function () {
    function ResourcesClass() {
    }
    return ResourcesClass;
}());
//# sourceMappingURL=ResourcesClass.js.map